import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const VerifyPage = () => {
  const navigate = useNavigate();

  useEffect (() => {
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get('token');

    fetch(process.env.REACT_APP_SERVER_URL + '/api/verify', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': token
      },
      body: JSON.stringify({})
    })
      .then(response => response.json())
      .then(data => {
        if (data.message === 'invalid token!') {
          console.log('unauthorized access')
          localStorage.removeItem('token');
          navigate('/');
          return;
        }

        localStorage.setItem('token', token);
        navigate('/dashboard');
      })
      .catch(error => console.error('Error:', error));
  }, [navigate]);

  return (
    <div className='login'>
      <p style={{textAlign: 'center',
                 color: 'var(--text-contrast-mid)',
                }}>
        Please wait, we are verifying your email.
      </p>
    </div>
  );
};

export default VerifyPage;
